const t = {
    en: {
      Home: "Home page",
      AboutUs: "About Us",
      Courses: "Courses",
      Contact: "Contact Us",
      PricingSchedule: "Pricing & Schedule",
      IndividualTutoring: "Individual Tutoring",
      Admission: "Admission",
      Admin: "Admin",
      AdmissionTitle: "Admission Application",
      AdmissionDescription:"Please complete all fields to submit your application.",
      StudentInformation: "Student Information",
      StudentFirstName: "First Name",
      StudentLastName: "Last Name",
      StudentGradeLevel: "Grade Level",
      SelectGradeLevel: "Select Grade Level",
      Elementary: "Elementary",
      HighSchool: "High school",
      Cegep: "Cegep",
      SchoolName: "School Name",
      ParentGuardianInformation: "Parent/Guardian Information",
      ParentFirstName: "First Name",
      ParentLastName: "Last Name",
      ParentEmail: "Email",
      ParentPhone: "Phone Number",
      TutoringPreferences: "Tutoring Preferences",
      SubjectPreferences: "Subject Preferences",
      French: "French",
      English: "English",
      Math: "Math",
      Science: "Science",
      History: "History",
      Other: "Other",
      IfOther: "If Other, please specify",
      TutoringType: "Tutoring Type",
      TutoringTypeSelect: "Select Tutoring Type",
      OneonOne: "One-on-One",
      Group: "Group Tutoring",
      Availability: "Availability",
      SelectAvailability: "Select Availability",
      OneonOneTimes: "Weekends (1:00 PM - 3:00 PM)",
      GroupTimesWeekDays: "Weekdays (4:30 PM - 7:30 PM)",
      GroupTimesWeekends: "Weekends (11:00 AM - 1:00 PM)",
      AdditionalInformation: "Additional Information",
      Specifysubject: "Specify subject",
      AnySpecificNeedsOrRequests: "Any specific needs or requests?",
      SubmitApplication: "Submit Application",
      ContactInfoTitle: "Information",
      ContactInfoIntro:"Have questions? We are here to help. Please contact us through any of the channels below.",
      Phone: "Phone",
      Email: "Email",
      Address: "Address",
      Languages: "Languages",
      LanguagesList: "English / French",
      FollowUs: "Follow Us",
      TutoringScheduleTitle: "Tutoring Schedule",
      ScheduleNote: "* Hours are subject to change during holidays.",
      GroupTutoring: "Group Tutoring",
      GroupDaysWeek: "Monday, Tuesday, Thursday",
      GroupDaysWeekend: "Saturday, Sunday",
      Dayclose: "Closed",
      GroupDayClose:"Wednesday, Friday",
      OneOnOneTutoring: "One-on-One Tutoring",
      OneOnOneMorning: "Sat, Sun",
      OneOnOneAfternoon: "Sat, Sun",
      ContactUsFormTitle: "Contact Us",
      RequiredField: "Required field",
      PlaceholderFirstName: "First Name",
      PlaceholderLastName: "Last Name",
      PlaceholderEmail: "Email",
      PlaceholderMessage: "Your message...",
      SelectOption: "Select an option",
      OptionStudent: "Tutoring-Student",
      OptionTutor: "Tutoring-Tutor",
      OptionGeneral: "General Inquiry / Question",
      SendMessageBtn: "Send Message",
      AlertSuccess: "Message sent successfully!",
      AlertError: "An error occurred. Please try again.",
      Morning: "Morning",
      Afternoon: "Afternoon",
      Evening: "Evening",
      MidDay: "Mid-day / Lunch",
      GroupTutoringOverview: "Group tutoring Overview",
      Schedule: "Schedule",
      GroupTutoringHours: "Group tutoring hours",
      MaxStudentsPerGroup: "Up to 8 students per group*",
      WeekdaysTitle: "Group Weekdays",
      WeekendTitle: "Weekend",
      Monday: "Monday",
      Tuesday: "Tuesday",
      Wednesday: "Wednesday",
      Thursday: "Thursday",
      Friday: "Friday",
      Saturday: "Saturday",
      Sunday: "Sunday",
      Closed: "Closed",
      TutoringPricesTitle: "Tutoring Prices",
      PricingSubtitle: "Choose the plan that fits your child's level.",
      ElementaryStudents: "Elementary Students",
      HighSchoolStudents: "High School Students",
      Month: "month",
      BasicPlan: "Basic Plan",
      FiveTimesWeek: "5 days per week",
      HomeworkSupport: "Homework support & subject reviews",
      ProgressUpdate: "Regular progress updates",
      HighSchoolExamPrep: "Preparation for Secondary admission exams",
      TutoringSubjectsLabel: "Tutoring subjects",
      ElementarySubjectsList: "English, French, Mathematics, Science, History.",
      HighSchoolSubjectsList: "Chemistry, Math, History, Physics, etc.",
      CollegeSubjectsList: "Literature, Chemistry, Physics, Math, etc.",
      IndividualTutoringOverview: "Individual tutoring Overview",
      IndividualTutoringHours: "Individual tutoring hours",
      WeekendsOnly: "Weekends only*",
      Hour: "Hour",
      CollegeStudents: "Cegep Students",
      ExamPrepAndSupport: "Exam preparation & homework support",
      ReadyToJoin: "Ready to Join Us?",
      ContactUsToEnroll: "Contact us today to enroll your child.",
      RegisterNow: "Register now",
      CentreHours: "Center Hours",
      Navigation: "Navigation",
      AllRightsReserved: "All rights reserved",
      BackToTop: "Back to top",
      DevelopedBy: "Developed by",
      termsAndConditions: "I agree that I will be bound by and undertake to observe the rules, regulations and policies in place at the center, including those contained in the course calendar and those on this registration form",
      TitleCoursesPage: "All tutoring programs are tailored to meet \n the individual needs of students.",
      AdmissionDescriptionCourses: "We give to our students all the support that they need for their studies to be able to learn faster and feel more confident at school.",
      //subjects
      SubjectMath: "Math",
      SubjectEnglish: "English",
      SubjectFrench: "French",
      SubjectHistory: "History",
      SubjectScience: "Science",
      SubjectChemistry: "Chemistry",
      SubjectPhysics: "Physics",
      SubjectLiterature: "Literature",
      //elementrary descriptions
      MathDescElem: "Comprehensive problem-solving and step-by-step mastery.",
      EnglishDescElem: "Reading comprehension, writing structure, and grammar.",
      FrenchDescElem: "Grammar, conjugation, and literature mastery.",
      HistoryDescElem: "Understanding historical events through analysis.",
      ScienceDescElem: "Exploring biology, chemistry, and physics basics.",
      //high school descriptions
      FrenchDescHigh: "Advanced grammar and Ministry exam preparation.",
      EnglishDescHigh: "Essay writing skills and oral communication.",
      HistoryDescHigh: "Critical analysis of Quebec and Canadian history.",
      MathDescHigh: "Specialized support for SN, CST, and TS pathways.",
      ScienceDescHigh: "General science and technology (ST/STE) programs.",
      ChemistryDescHigh: "In-depth study of reactions and molecular behavior.",
      PhysicsDescHigh: "Mastering kinematics, dynamics, and motion laws.",
      //cegep descriptions
      LitDescCegep: "College-level essays and Exit Exam preparation.",
      ChemDescCegep: "General, solutions, and organic chemistry.",
      PhysDescCegep: "Mechanics, electricity, and wave physics.",
      MathDescCegep: "Differential and integral calculus and linear algebra.",

      ToastFormSucess: "Form submitted successfully!",
      ToastFormDescription: "Your application has been sent successfully. We will contact you soon.",
      FormSubmittedSuccessfully: "Your application has been sent successfully. We will contact you soon.",
      AlertErrorDescription: "Please try again later",
      PleaseSelectAtLeastOneSubject: "Please select at least one subject",
      PleaseSpecifyTheOtherSubject: "Please specify the other subject",
      informationSupp: "Additional information:",
      NoInformation: "No additional information available at this time.",
      ClickForDetails: "Click to see details",

      ApproachTitle: "Our Approach",
      SubjectsTitle: "Subjects Covered",
      // Elementary approaches and subjects
      // Text Generated by Gemini :
      MathApproachElem: "Learning through play and hands-on manipulation to build a solid foundation in calculation.",
      MathSubjectsElem: "Mental math, Geometry, Fractions, Word problems",
      EnglishApproachElem: "Immersion through play and natural development of oral expression.",
      EnglishSubjectsElem: "Reading comprehension, Grammar, Vocabulary enrichment, Pronunciation",
      FrenchApproachElem: "Fun and engaging learning of core language rules.",
      FrenchSubjectsElem: "Reading, Handwriting, Dictations",
      HistoryApproachElem: "Captivating storytelling to explore the past and navigate time and space.",
      HistorySubjectsElem: "Timelines, Canadian geography, Evolution of societies",
      ScienceApproachElem: "Sparking curiosity through observation and understanding the world around us.",
      ScienceSubjectsElem: "The human body, Animals, Plants, Weather, Environment",

      // High school approaches and subjects
      MathApproachHigh: "Specialized tutoring by pathway (SN, CST, TS).",
      MathSubjectsHigh: "Algebra, Functions (exponential and log), Trigonometry, Geometry, Probability/statistics",
      PhysicsApproachHigh: "Problem-solving methods and intuitive understanding of the laws of nature.",
      PhysicsSubjectsHigh: "Optics (lenses and mirrors), Kinematics, Dynamics, Energy transformation",
      ChemApproachHigh: "Mastery of lab calculations and simplification of chemical reactions.",
      ChemistrySubjectsHigh: "Properties of matter, Chemical reactions, Organic chemistry, Chemistry of solutions",
      FrenchApproachHigh: "Advanced grammar support and targeted preparation for Ministry exams.",
      FrenchSubjectsHigh: "Textual analysis, Advanced grammar, Essay writing, Quebec and French literature",
      EnglishApproachHigh: "Fluency improvement and rigorous structure for written productions.",
      EnglishSubjectsHigh: "Essay writing, Oral communication, Textual analysis, English literature",
      HistoryApproachHigh: "In-depth critical analysis of Quebec and Canadian history for a comprehensive understanding.",
      HistorySubjectsHigh: "History of Quebec, History of Canada, Major world events, Historical source analysis, Preparation for the Secondary 4 Ministry exams",
      ScienceApproachHigh: "Technical and theoretical support for ST and STE programs.",
      ScienceSubjectsHigh: "The material world, Earth and space, the living world, and Technological challenges (ST/STE)",

      // Cegep approaches and subjects
      LitApproachCegep: "Academic coaching focused on structural logic.",
      LitSubjectsCegep: "Literary dissertation, Argumentative structure, Preparation for the Ministerial French Exit Exam (EUF)",
      ChemApproachCegep: "Simplification of molecular concepts and step-by-step calculation methods.",
      ChemSubjectsCegep: "General Chemistry, Chemistry of Solutions, and Organic chemistry",
      PhysApproachCegep: "Visualization of physical concepts and resolution strategies for mathematical problems.",
      PhysSubjectsCegep: "Mechanics, Electricity and Magnetism, Waves and Modern physics",
      MathApproachCegep: "Advanced mathematical techniques and problem-solving strategies for college-level courses.",
      MathSubjectsCegep: "Calculus, Linear algebra, Differential equations, Discrete mathematics",
      // End of text generated by Gemini

      HeroTitle: "French, math and science tutoring in Montreal",
      HeroSecondary: "A1 Tutorial offers tutoring in French, mathematics and science, plus homework help, for elementary, high school and CEGEP students.",
      HomeElementaryTitle: "Elementary tutoring",
      HomeHighSchoolTitle: "High school tutoring",
      HomeCegepTitle: "CEGEP tutoring",
      SubjectsHeading: "Subjects offered in Montreal",
      SubjectFrenchTitle: "French tutoring in Montreal",
      SubjectFrenchDesc: "Help with reading, grammar, writing and school assignments, for elementary, high school and CEGEP students, in Parc-Extension.",
      SubjectMathTitle: "Math tutoring in Montreal",
      SubjectMathDesc: "Algebra, geometry and exam preparation, from elementary school to CEGEP.",
      SubjectScienceTitle: "Science tutoring in Montreal",
      SubjectScienceDesc: "Science in elementary and high school, chemistry and physics in high school and CEGEP.",
      FaqHeading: "Frequently asked questions",
      SectionDivider: "Support for every stage of learning",
      SubtitleInfo: "We provide structured academic support that builds independent learning skills",
    
      // Cards
      ElementaryTitle: "Elementary Students 📗",
      ElementaryDesc: "Elementary tutoring in Montreal: French, mathematics, science and homework help.",
      ElementaryPoint1: "Individual tutoring & Group tutoring",
      ElementaryPoint2: "Explanations step-by-step",
      ElementaryPoint3: "Homework guidance + practice",
      ElementaryPoint4: "Motivation and confidence",

      HighSchoolTitle: "High School Students 📘",
      HighSchoolDesc: "High school tutoring in Montreal: French, mathematics, science and exam preparation.",
      HighSchoolPoint1: "Individual tutoring & Group tutoring",
      HighSchoolPoint2: "Exam preparation",
      HighSchoolPoint3: "Improving study strategies",
      HighSchoolPoint4: "Constant follow-up throughout their studies",

      CollegeTitle: "College Students 📚",
      CollegeDesc: "CEGEP tutoring in Montreal: mathematics, science and French.",
      CollegePoint1: "Advanced subject progression",
      CollegePoint2: "Individual tutoring",
      CollegePoint3: "Exam preparation",

      GoogleReviewsSubtitle: "Google Reviews from our students and parents",
      AddressStreet:"892 Jean-Talon West",
      AddressCity: "Montreal, QC, H3N 1S6",
      Highlight: "Over 18 years of academic support in Montreal",
      Intro: "Discover the story, mission, and values of the A1 Tutorial tutoring center in Montreal.",
      Title1: "A1 Tutorial",
      Content1: "A1 Tutorial is a long-standing tutoring center in the heart of the Parc-Extension neighbourhood of Montreal. For over a decade, we have formed strong connections to our community in Parc-Extension and in the Greater Montreal area by providing exceptional homework help to elementary, high school, and College students at our center. Our way of teaching reflects the needs of the students, whether it be educational focus training or building confidence in test taking.",
      Title2: "How It Started",
      Content2: "Through his accounting work, Kazi Alam Babu, the founder and director of A1 Tutorial, saw that so many parents would come to their meetings with school letters trying to understand what was written. He realised that the parents, primarily new immigrants, were struggling with the language barrier and were unable to support their kids in their homework. In an effort to help his community, Kazi Alam Babu decided to open this tutoring center in Montreal.",
      CoreValues: "Our Core Values",
      Respect: "Respect",
      RespectDesc: "We strongly believe that showing our students the respect they deserve and treating them all like equals truly impacts their journey at our learning center and builds stronger ties with our tutors and each other.",
      Trust: "Trust",
      TrustDesc: "Our learning center started with the acute need to serve the immigrant, newcomer families that make up the neighbourhood and provide relief to hard-working parents by helping their children perform at school.",
      Community: "Community",
      CommunityDesc: "Our Montreal based tutors work very hard to stimulate minds but also build lasting trust with our students so that they can open up to us and let us help them face difficulties and find solutions to problems together.",
      Inclusion: "Inclusion",
      InclusionDesc: "A1 Tutorial is a center where students from diverse countries, different parts of the city, and different schools come together to strive to improve their confidence and performance at school. Whether you need a math tutor, English tutor, French tutor or help with any other subject, we make everyone feel welcome.",
      OurServices: "Our Services",
      ClassOf8: "Class of 8 students",
      ClassOf8Desc: "Our group classes are made up of 8 students so there is a perfect balance of group learning and each individual student receiving the care and attention they need. We have tutors with expertise in teaching English, French, Mathematics, Science, History and more!",
      OneOnOne: "One-on-one tutoring",
      OneOnOneDesc: "For students who need extra attention to improve their foundation and work on tricky problems, A1 Tutorial provides 1-on-1 private tutoring. We ensure our tutors focus on the weaknesses of the individual student, help them tackle complicated problems through proven systems and be a form of moral support for the student.",
      HighSchoolExams: "High school exam prep",
      HighSchoolExamsDesc: "Intensive review sessions focused on mastering key concepts and acquiring strategic methodologies to approach final exams with renewed confidence and clarity.",
      AdmissionExams: "Admission exams",
      AdmissionExamsDesc: "A rigorous and specialized training program, specifically structured to help students succeed in competitive entrance exams for any secondary school, specialized academic programs, or selective institutions.",
      Sadia: "Sadia",
      AdminLogin: "Login",
      TestimonialShaan : "My experience here will be of great value in the future development of my academic and professional career. The teaching staff and management have been helpful, stimulating, and encouraging.",
      TestimonialPrionkari: "I have been a student at A1 in the past, and it completely changed my life for the better. I remember struggling before, but with the immense help I received from A1, my grades improved drastically. Their hardworking tutors have so much insight and truly bring out the best in their students. Now, I can proudly say that I am a student at Polytechnique Montréal in software engineering, and A1 played a big part in securing a bright future for me.",
      TestimonialSadia : "I wasn’t a particularly strong student during my first years of primary school, and I had a lot of difficulty understanding French, math, and science. However, with the great help of the amazing A1 tutors, along with their enthusiasm and encouragement, my teachers, parents, and everyone around me noticed a significant improvement in my grades by the end of primary school. I maintained that level of academic performance and successfully graduated from high school with strong grades. I am currently pursuing a bachelor’s degree in biomedical sciences at the University of Montreal",
      TestimonialIntro : "We take pride in caring for our students and supporting their development in a holistic way. Our approach not only promotes better performance in school, but also fosters well-rounded adaptation to their environments.",
    },
    // fr: {
    //   Home: "Accueil",
    //   AboutUs: "À propos de nous",
    //   Courses: "Cours",
    //   Contact: "Contactez-nous",
    //   PricingSchedule: "Tarification & Horaire",
    //   IndividualTutoring: "Tutorat individuel",
    //   Admission: "Inscription",
    //   Admin: "Admin",
    //   AdmissionTitle: "Demande d'admission",
    //   AdmissionDescription:"Veuillez remplir tous les champs pour soumettre votre demande.",
    //   StudentInformation: "Informations sur l'étudiant",
    //   StudentFirstName: "Prénom",
    //   StudentLastName: "Nom de famille",
    //   StudentGradeLevel: "Niveau scolaire",
    //   SelectGradeLevel: "Sélectionnez le niveau scolaire",
    //   Elementary: "Primaire",
    //   HighSchool: "Secondaire",
    //   Cegep: "Cégep",
    //   SchoolName: "Nom de l'école",
    //   ParentGuardianInformation: "Informations sur le parent/tuteur",
    //   ParentFirstName: "Prénom",
    //   ParentLastName: "Nom de famille",
    //   ParentEmail: "Email",
    //   ParentPhone: "Numéro de téléphone",
    //   TutoringPreferences: "Préférences de tutorat",
    //   SubjectPreferences: "Préférences de matière",
    //   French: "Français",
    //   English: "Anglais",
    //   Math: "Mathématiques",
    //   Science: "Sciences",
    //   History: "Histoire",
    //   Other: "Autre",
    //   IfOther: "Si autre, veuillez préciser",
    //   TutoringType: "Type de tutorat",
    //   TutoringTypeSelect: "Sélectionnez le type de tutorat",
    //   OneonOne: "Un à un",
    //   Group: "Tutorat de groupe",
    //   Availability: "Disponibilité",
    //   SelectAvailability: "Sélectionnez la disponibilité",
    //   OneonOneTimes: "Weekends (13h00 - 15h00)",
    //   GroupTimesWeekDays: "Semaine (16h30 - 19h30)",
    //   GroupTimesWeekends: "Weekends (11h00 - 13h00)",
    //   AdditionalInformation: "Informations supplémentaires",
    //   Specifysubject: "Préciser le sujet",
    //   AnySpecificNeedsOrRequests: "Des besoins ou des demandes particulières ?",
    //   SubmitApplication: "Soumettre la demande",
    //   ContactInfoTitle: "Information",
    //   ContactInfoIntro:"Vous avez des questions ? Nous sommes là pour vous aider. Contactez-nous via l'un des canaux ci-dessous.",
    //   Phone: "Téléphone",
    //   Email: "Courriel",
    //   Address: "Adresse",
    //   Languages: "Langues",
    //   LanguagesList: "Anglais / Français",
    //   FollowUs: "Suivez-nous",
    //   TutoringScheduleTitle: "Horaire de Tutorat",
    //   ScheduleNote:"* Les heures sont sujettes à changement pendant les jours fériés.",
    //   GroupTutoring: "Tutorat en Groupe",
    //   GroupDaysWeek: "Lundi, Mardi, Jeudi",
    //   GroupDaysWeekend: "Samedi, Dimanche",
    //   Dayclose: "Fermé",
    //   GroupDayClose:"Mercredi, Vendredi",
    //   OneOnOneTutoring: "Tutorat Individuel",
    //   OneOnOneMorning: "Sam, Dim",
    //   OneOnOneAfternoon: "Sam, Dim",
    //   ContactUsFormTitle: "Contactez-nous",
    //   RequiredField: "Champ obligatoire",
    //   PlaceholderFirstName: "Prénom",
    //   PlaceholderLastName: "Nom",
    //   PlaceholderEmail: "Courriel",
    //   PlaceholderMessage: "Votre message...",
    //   SelectOption: "Sélectionnez une option",
    //   OptionStudent: "Tutorat - Étudiant",
    //   OptionTutor: "Tutorat - Tuteur",
    //   OptionGeneral: "Demande générale / Question",
    //   SendMessageBtn: "Envoyer le message",
    //   AlertSuccess: "Message envoyé avec succès !",
    //   AlertError: "Une erreur est survenue. Veuillez réessayer.",
    //   Morning: "Matin",
    //   Afternoon: "Après-midi",
    //   Evening: "Soirée",
    //   MidDay: "Midi / Lunch",
    //   GroupTutoringOverview: "Aperçu du tutorat de groupe",
    //   Schedule: "Horaire",
    //   GroupTutoringHours: "Heures de tutorat de groupe",
    //   MaxStudentsPerGroup: "Jusqu'à 8 étudiants par groupe*",
    //   WeekdaysTitle: "En semaine",
    //   WeekendTitle: "Fin de semaine",
    //   Monday: "Lundi",
    //   Tuesday: "Mardi",
    //   Wednesday: "Mercredi",
    //   Thursday: "Jeudi",
    //   Friday: "Vendredi",
    //   Saturday: "Samedi",
    //   Sunday: "Dimanche",
    //   Closed: "Fermé",
    //   TutoringPricesTitle: "Tarifs de tutorat",
    //   PricingSubtitle: "Choisissez le plan qui correspond au niveau de votre enfant.",
    //   ElementaryStudents: "Étudiants du primaire",
    //   HighSchoolStudents: "Étudiants du secondaire",
    //   Month: "mois",
    //   BasicPlan: "Plan de base",
    //   FiveTimesWeek: "5 fois par semaine",
    //   HomeworkSupport: "Soutien aux devoirs et révision des matières",
    //   ProgressUpdate: "Retour de progrès constants",
    //   HighSchoolExamPrep: "Préparation aux examens d'admission du secondaire",
    //   TutoringSubjectsLabel: "Matières enseignées",
    //   ElementarySubjectsList: "Anglais, Français, Mathématiques, Sciences, Histoire.",
    //   HighSchoolSubjectsList: "Maths, Chimie, Physique, Anglais, Français, etc.",
    //   IndividualTutoringOverview: "Aperçu du tutorat individuel",
    //   IndividualTutoringHours: "Heures de tutorat individuel",
    //   WeekendsOnly: "Fin de semaine seulement*",
    //   Hour: "heure",
    //   CollegeStudents: "Étudiants au collégial",
    //   ExamPrepAndSupport: "Préparation aux examens et soutien aux devoirs",
    //   ReadyToJoin: "Prêt à nous rejoindre ?",
    //   ContactUsToEnroll: "Contactez-nous aujourd'hui pour inscrire votre enfant.",
    //   RegisterNow: "Inscrivez-vous dès maintenant",
    //   CentreHours: "Heures d'ouverture",
    //   Navigation: "Navigation",
    //   AllRightsReserved: "Tous droits réservés",
    //   BackToTop: "Retour en haut",
    //   DevelopedBy: "Développé par",
    //   termsAndConditions: "Je reconnais que je serai lié par les règles, règlements et politiques en vigueur au center, y compris celles contenues dans le calendrier des cours et celles figurant sur ce formulaire d'inscription",
    //   TitleCoursesPage: "Tous nos programmes de tutorat sont adaptés \n aux besoins individuels des élèves.",
    //   AdmissionDescriptionCourses: "Nous offrons à nos élèves tout le soutien nécessaire pour leurs études afin qu'ils puissent apprendre plus rapidement et se sentir plus en confiance à l'école.",
    //   //subjects
    //   SubjectMath: "Mathématiques",
    //   SubjectEnglish: "Anglais",
    //   SubjectFrench: "Français",
    //   SubjectHistory: "Histoire",
    //   SubjectScience: "Sciences",
    //   SubjectChemistry: "Chimie",
    //   SubjectPhysics: "Physique",
    //   SubjectLiterature: "Littérature",
    //   //elementary descriptions
    //   MathDescElem: "Résolution de problèmes et maîtrise étape par étape.",
    //   EnglishDescElem: "Compréhension de lecture, structure d'écriture et grammaire.",
    //   FrenchDescElem: "Maîtrise de la grammaire, de la conjugaison et de la littérature.",
    //   HistoryDescElem: "Compréhension des événements par l'analyse.",
    //   ScienceDescElem: "Exploration de la biologie, de la chimie et de la physique.",
    //   //high school descriptions
    //   FrenchDescHigh: "Grammaire avancée et préparation aux examens ministériels.",
    //   EnglishDescHigh: "Rédaction d'essais et communication orale.",
    //   HistoryDescHigh: "Analyse critique de l'histoire du Québec et du Canada.",
    //   MathDescHigh: "Soutien ciblé pour les parcours SN, CST et TS.",
    //   ScienceDescHigh: "Programmes de science et technologie (ST/STE).",
    //   ChemistryDescHigh: "Étude des réactions et du comportement moléculaire.",
    //   PhysicsDescHigh: "Maîtrise de la cinématique et des lois du mouvement.",
    //   //cegep descriptions
    //   LitDescCegep: "Dissertation collégiale et Épreuve uniforme de français.",
    //   ChemDescCegep: "Chimie générale, des solutions et organique.",
    //   PhysDescCegep: "Mécanique, électricité et physique des ondes.",
    //   MathDescCegep: "Calcul différentiel, intégral et algèbre linéaire.",

    //   ToastFormSucess: "Formulaire soumis avec succès !",
    //   ToastFormDescription: "Votre demande a été envoyée avec succès. Nous vous contacterons bientôt.",
    //   FormSubmittedSuccessfully: "Votre demande a été envoyée avec succès. Nous vous contacterons bientôt.",
    //   AlertErrorDescription: "Nous n'avons pas pu traiter votre demande. Veuillez réessayer.",
    //   PleaseSelectAtLeastOneSubject: "Veuillez sélectionner au moins une matière",
    //   PleaseSpecifyTheOtherSubject: "Veuillez préciser l'autre matière",
    //   informationSupp: "Informations supplémentaires :",
    //   NoInformation: "Aucune information supplémentaire disponible pour le moment.",
    //   ClickForDetails: "Cliquez pour voir les détails",

    //   ApproachTitle: "Notre approche",
    //   SubjectsTitle: "Matières abordées",
    //   //elementary approaches and subjects
    //   // Texte Généré par Gemini :
    //   MathApproachElem: "Apprentissage par le jeu et manipulation concrète pour bâtir une base solide en calcul.",
    //   MathSubjectsElem: "Calcul mental, Géométrie, fractions, Résolution de problèmes",
    //   EnglishApproachElem: "Immersion par le jeu et développement naturel de l'expression orale.",
    //   EnglishSubjectsElem: "Compréhension de lecture, GRammaire, Enrichissement du vocabulaire, Prononciation",
    //   FrenchApproachElem: "Apprentissage ludique des règles de base.",
    //   FrenchSubjectsElem: "Lecture, Calligraphie, Dictées, Conjugaison simple",
    //   HistoryApproachElem: "Récits captivants pour explorer le passé et se repérer dans le temps et l'espace.",
    //   HistorySubjectsElem: "Lignes du temps, Géographie canadienne, Évolution des sociétés",
    //   ScienceApproachElem: "Éveil de la curiosité par l'observation et la compréhension du monde qui nous entoure.",
    //   ScienceSubjectsElem: "Le corps humain, Les animaux, les plantes, Météo et environnement",
    //   //high school approaches and subjects
    //   MathApproachHigh: "Tutorat spécialisé par parcours (SN, CST, TS)",
    //   MathSubjectsHigh: "Algèbre, fonctions (exponentielles et log), Trigonométrie, Géométrie , Probabilités/statistiques.",
    //   PhysicsApproachHigh: "Méthodes de résolution de problèmes et compréhension intuitive des lois de la nature.",
    //   PhysicsSubjectsHigh: "Optique (lentilles et miroirs), Cinématique, Dynamique et transformation de l'énergie.",
    //   ChemApproachHigh: "Maîtrise des calculs de laboratoire et vulgarisation des réactions chimiques.",
    //   ChemistrySubjectsHigh: "Propriétés de la matière, Réactions chimiques, Chimie organique, Chimie des solutions.",
    //   FrenchApproachHigh: "Soutien avancé en grammaire et préparation ciblée aux examens du ministère.",
    //   FrenchSubjectsHigh: "Analyse de textes, Grammaire avancée, Rédaction d'essais, Littérature québécoise et française",
    //   EnglishApproachHigh: "Amélioration de la fluidité et structure rigoureuse pour les productions écrites.",
    //   EnglishSubjectsHigh: "Rédaction d'essais, Communication orale, Analyse de textes, Littérature anglophone",
    //   HistoryApproachHigh: "Analyse critique approfondie de l'histoire du Québec et du Canada pour une compréhension complète.",
    //   HistorySubjectsHigh: "Histoire du Québec, Histoire du Canada, Événements mondiaux majeurs, Analyse de sources historiques, Préparation à l'examen ministériel de S4.",
    //   ScienceApproachHigh: "Soutien technique et théorique pour les programmes ST et STE.",
    //   ScienceSubjectsHigh: "L'univers matériel, La Terre et l'espace, L'univers vivant et les défis technologiques (ST/STE).",
    //   //cegep approaches and subjects
    //   LitApproachCegep: "Encadrement académique pour la logique de structure",
    //   LitSubjectsCegep: "Dissertation littéraire, Structure argumentative, Préparation à l'Épreuve uniforme (EUF).",
    //   ChemApproachCegep: "Simplification des concepts moléculaires et méthode étape par étape pour les calculs.",
    //   ChemSubjectsCegep: "Chimie générale, Chimie des solutions , Chimie organique.",
    //   PhysApproachCegep: "Visualisation des concepts physiques et stratégie de résolution pour les problèmes mathématiques.",
    //   PhysSubjectsCegep: "Mécanique, Électricité et magnétisme, Ondes et physique moderne.",
    //   MathApproachCegep: "Techniques mathématiques avancées et stratégies de résolution de problèmes pour les cours de niveau collégial.",
    //   MathSubjectsCegep: "Calcul, Algèbre linéaire, Équations différentielles, Mathématiques discrètes.",
    //   // fin du texte généré par Gemini

    //   HeroTitle: "Responsabiliser les jeunes esprits grâce à une éducation et un mentorat personnalisés. Notre mission est d'aider chaque élève à libérer son plein potentiel et à atteindre l'excellence académique.",
    //   HeroSecondary: "Centre de tutorat A1 engagé à fournir une éducation de haute qualité dans un environnement stimulant qui favorise la curiosité, la confiance et la réussite.",
    //   SectionDivider: "Un soutien pour chaque étape de l'apprentissage",
    //   SubtitleInfo: "Nous offrons un soutien académique structuré qui développe des compétences d'apprentissage autonomes",

    //   // Cartes
    //   ElementaryTitle: "Élèves du Primaire 📗",
    //   ElementaryDesc: "Offrir les meilleures compétences en lecture, en mathématiques et en habitudes d'apprentissage.",
    //   ElementaryPoint1: "Tutorat individuel et tutorat de groupe",
    //   ElementaryPoint2: "Explications étape par étape",
    //   ElementaryPoint3: "Aide aux devoirs et pratique",
    //   ElementaryPoint4: "Motivation et confiance en soi",

    //   HighSchoolTitle: "Élèves du Secondaire 📘",
    //   HighSchoolDesc: "Amélioration des notes, pratique d'examens et suivi académique",
    //   HighSchoolPoint1: "Tutorat individuel et tutorat de groupe",
    //   HighSchoolPoint2: "Préparation aux examens",
    //   HighSchoolPoint3: "Amélioration des stratégies d'étude",
    //   HighSchoolPoint4: "Suivi constant tout au long de leur parcours",

    //   CollegeTitle: "Étudiants du Collégial 📚",
    //   CollegeDesc: "Soutien académique avancé",
    //   CollegePoint1: "Progression dans les matières avancées",
    //   CollegePoint2: "Tutorat individuel",
    //   CollegePoint3: "Préparation aux examens",
    //   GoogleReviewsSubtitle: "Avis Google de nos étudiants et parents",
    //   AddressStreet:"892 rue Jean-Talon Ouest",
    //   AddressCity: "Montréal, QC, H3N 1S6",
    //   Highlight: "Plus de 18 ans de soutien scolaire à Montréal",
    //   Intro: "Découvrez l'histoire, la mission et les valeurs du centre de tutorat A1 Tutorial à Montréal.",
    //   Title1: "A1 Tutorial",
    //   Content1: "A1 Tutorial est un centre de tutorat établi de longue date au cœur du quartier Parc-Extension à Montréal. Depuis plus d'une décennie, nous avons tissé des liens étroits avec notre communauté de Parc-Extension et de la grande région de Montréal en offrant une aide aux devoirs exceptionnelle aux élèves du primaire, du secondaire et du collégial. Notre approche pédagogique reflète les besoins des élèves, qu'il s'agisse de concentration éducative ou de renforcer la confiance lors des examens.",
    //   Title2: "Nos débuts",
    //   Content2: "Dans le cadre de son travail en comptabilité, Kazi Alam Babu, fondateur et directeur d'A1 Tutorial, a constaté que de nombreux parents arrivaient en réunion avec des lettres d'école sans comprendre leur contenu. Il a réalisé que ces parents, principalement des nouveaux arrivants, étaient freinés par la barrière de la langue et ne pouvaient pas soutenir leurs enfants dans leurs devoirs. Soucieux d'aider sa communauté, Kazi Alam Babu a décidé d'ouvrir ce centre de tutorat à Montréal.",
    //   CoreValues: "Nos valeurs fondamentales",
    //   Respect: "Respect",
    //   RespectDesc: "Nous croyons fermement qu'accorder aux élèves le respect qu'ils méritent et les traiter comme des égaux influence véritablement leur parcours au sein de notre centre d'apprentissage et renforce les liens avec nos tuteurs et entre eux.",
    //   Trust: "Confiance",
    //   TrustDesc: "Notre centre d'apprentissage est né du besoin criant de servir les familles immigrantes et les nouveaux arrivants qui composent le quartier, afin d'offrir un soutien aux parents travailleurs en aidant leurs enfants à réussir à l'école.",
    //   Community: "Communauté",
    //   CommunityDesc: "Nos tuteurs basés à Montréal travaillent dur pour stimuler les esprits, mais aussi pour bâtir une confiance durable avec nos élèves, afin qu'ils puissent s'ouvrir à nous et nous laisser les aider à surmonter leurs difficultés et à trouver des solutions ensemble.",
    //   Inclusion: "Inclusion",
    //   InclusionDesc: "A1 Tutorial est un centre où des élèves issus de divers pays, de différents quartiers et d'écoles variées se réunissent pour améliorer leur confiance et leur performance scolaire. Que vous ayez besoin d'un tuteur en mathématiques, en anglais, en français ou dans toute autre matière, nous accueillons tout le monde à bras ouverts.",
    //   OurServices: "Nos Services",
    //   ClassOf8: "Classes de 8 élèves",
    //   ClassOf8Desc: "Nos cours de groupe sont limités à 8 élèves afin d'offrir un équilibre parfait entre l'apprentissage collectif et l'attention personnalisée dont chaque étudiant a besoin. Nos tuteurs possèdent une expertise approfondie dans l'enseignement du français, de l'anglais, des mathématiques, des sciences, de l'histoire et bien plus encore.",
    //   OneOnOne: "Tutorat individuel",
    //   OneOnOneDesc: "Pour les élèves ayant besoin d'un soutien accru afin de consolider leurs bases et de surmonter des difficultés spécifiques, A1 Tutorial propose un tutorat privé individuel. Nos tuteurs se concentrent sur les points faibles de chaque élève, les aident à résoudre des problèmes complexes grâce à des méthodes éprouvées et leur offrent un soutien moral essentiel à leur réussite.",
    //   HighSchoolExams: "Préparation aux examens",
    //   HighSchoolExamsDesc: "Des séances de révision intensives axées sur la maîtrise des concepts clés et l'acquisition de méthodes stratégiques pour aborder les épreuves avec une confiance renouvelée.",
    //   AdmissionExams: "Examens d'admission",
    //   AdmissionExamsDesc: "Un entraînement rigoureux et spécialisé, spécifiquement structuré pour aider les élèves à réussir les examens d'entrée pour toute école secondaire, programme académique spécialisé ou institution sélective.",
    //   Sadia: "Sadia",
    //   AdminLogin: "Connexion",
    // },
};

export default t; 